import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from "@angular/router";
import { CurrencyPipe } from '@angular/common';
import { provideFunctions, getFunctions } from '@angular/fire/functions';

import {environment} from '../environments/environment';

import {FormsModule } from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';

import {MatNativeDateModule} from '@angular/material/core';

import {ToastrModule} from "ngx-toastr";

import { getApp, provideFirebaseApp } from "@angular/fire/app";
import { initializeFirestore, provideFirestore } from "@angular/fire/firestore";
import { AngularFireModule } from '@angular/fire/compat';
import { SETTINGS as FIRESTORE_SETTINGS } from '@angular/fire/compat/firestore';
import { AngularFireFunctionsModule, REGION } from "@angular/fire/compat/functions";
import { AngularFireDatabaseModule } from "@angular/fire/compat/database";
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { LoginComponent } from './login.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WaiverSignComponent } from './v2/components/public/waiver-builder/waiver-sign.component';
import { WaiverSignRedirectComponent } from './v2/components/public/waiver-builder/waiver-sign-redirect.component';
import { EnvelopeSignComponent } from './v2/components/public/waiver-builder/envelope-sign.component';
import { SignaturePadDirective } from './v2/components/public/waiver-builder/directives/signature-pad.directive';
import { PhoneFormatDirective } from './v2/components/public/waiver-builder/directives/phone-format.directive';
import { DateOfBirthPickerComponent } from './v2/components/commons/date-of-birth-picker/date-of-birth-picker.component';
import { PhoneFormatPipe } from './v2/components/public/waiver-builder/pipes/phone-format.pipe';
import { LazyLoadMediaDirective } from './utils/lazy-load-media.directive';


@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        WaiverSignComponent,
        WaiverSignRedirectComponent,
        EnvelopeSignComponent,
        ],
    imports: [
        SignaturePadDirective,
        PhoneFormatDirective,
        DateOfBirthPickerComponent,
        PhoneFormatPipe,
        NgbModule,
        BrowserModule,
        AppRoutingModule,
        NgbModalModule,
        BrowserAnimationsModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireFunctionsModule,
        AngularFireAnalyticsModule,
        AngularFireDatabaseModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule,
        MatNativeDateModule,
        ToastrModule.forRoot(),
        FontAwesomeModule,
        LazyLoadMediaDirective
    ],
    providers: [
      CurrencyPipe,
      { provide: REGION, useValue: environment.google.region },
      // Mirror ignoreUndefinedProperties on the compat AngularFirestore
      // instance (line below already sets it on the modular one). Without
      // this, compat writes throw on any undefined field — easy to hit
      // when spreading optional-fielded models like Participant into a
      // doc update.
      { provide: FIRESTORE_SETTINGS, useValue: { ignoreUndefinedProperties: true } },
      provideFirebaseApp(() => getApp()),
      provideFirestore(() => {
        return initializeFirestore(getApp(), {
          ignoreUndefinedProperties: true,
          // Some networks/devices (certain mobile wifi, corporate proxies, iOS)
          // block Firestore's default WebChannel streaming transport, so
          // document reads hang until WebChannel times out at ~30s and only
          // then fetch — instant on desktop but ~30s on the phone, even though
          // the payload is tiny (~17 docs / 392KB). Diagnosed from a 30s
          // `getDocsFromServer` where count + parse were both fast.
          //
          // experimentalAutoDetectLongPolling didn't detect the block on the
          // affected network, so we force long polling outright: it skips the
          // WebChannel attempt entirely and uses HTTP long polling, which works
          // through proxies/firewalls. Minor extra latency on healthy networks,
          // but reliable everywhere.
          experimentalForceLongPolling: true,
        })
      }),
      provideFunctions(() => getFunctions())
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
